import _classCallCheck from "@babel/runtime-corejs2/helpers/classCallCheck";
import _createClass from "@babel/runtime-corejs2/helpers/createClass";
import _inherits from "@babel/runtime-corejs2/helpers/inherits";
import _createSuper from "@babel/runtime-corejs2/helpers/createSuper";
import * as React from 'react';
import * as Sentry from '@sentry/react';
import { Error as ErrorView } from '../Error';
var ErrorBoundary = /*#__PURE__*/function (_React$Component) {
  _inherits(ErrorBoundary, _React$Component);
  var _super = _createSuper(ErrorBoundary);
  function ErrorBoundary() {
    var _this;
    _classCallCheck(this, ErrorBoundary);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _this.state = {
      hasError: false
    };
    return _this;
  }
  _createClass(ErrorBoundary, [{
    key: "componentDidUpdate",
    value:
    // Allows navigating away from an errored screen / route.
    function componentDidUpdate(prevProps) {
      if (this.state.hasError && this.props.children !== prevProps.children) {
        // eslint-disable-next-line react/no-did-update-set-state
        this.setState({
          hasError: false
        });
      }
    }
  }, {
    key: "componentDidCatch",
    value: function componentDidCatch(error, info) {
      Sentry.captureException(error, {
        extra: info
      });
    }
  }, {
    key: "render",
    value: function render() {
      if (this.state.hasError) {
        return /*#__PURE__*/React.createElement(ErrorView, {
          backLink: "/"
        });
      }
      if (this.props.children) {
        return this.props.children;
      }
      return null;
    }
  }], [{
    key: "getDerivedStateFromError",
    value: function getDerivedStateFromError() {
      return {
        hasError: true
      };
    }
  }]);
  return ErrorBoundary;
}(React.Component);
export default ErrorBoundary;